import React from 'react';
import ChatBoxButtonOpen from './ChatBoxButtonOpen/ChatBoxButtonOpen';
import ChatboxWindow from './ChatboxWindow/ChatboxWindow';
import { useConversationStateContext } from '../context/ConversationContext';

const Chatbox = () => {
const {chatboxColor} =useConversationStateContext();
    return (
        <>
          <ChatBoxButtonOpen chatboxColor={chatboxColor} />
          <ChatboxWindow />
        </>
    );
};

export default Chatbox;